/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Not_AuthenticatedInputs */



/**
* | output |
* | --- |
* | "You're not signed in." |
*
* @param {Auth_Error_Not_AuthenticatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_error_not_authenticated = /** @type {((inputs?: Auth_Error_Not_AuthenticatedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Not_AuthenticatedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous n'êtes pas connecté.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No ha iniciado sesión.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você não está conectado.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non hai effettuato l'accesso.")
	return /** @type {LocalizedString} */ ("You're not signed in.")
});